import React, { CSSProperties, FunctionComponent, useState } from 'react';
import { Modal } from '../modal/modal-component';
import styles from './energy-arrow-component.module.scss';
import { ReactComponent as ArrowA } from './images/energy-arrow-a.svg';
import { ReactComponent as ArrowB } from './images/energy-arrow-b.svg';
import { ReactComponent as ArrowC } from './images/energy-arrow-c.svg';
import { ReactComponent as ArrowD } from './images/energy-arrow-d.svg';
import { ReactComponent as ArrowE } from './images/energy-arrow-e.svg';
import { ReactComponent as ArrowF } from './images/energy-arrow-f.svg';
import { ReactComponent as ArrowG } from './images/energy-arrow-g.svg';

export type Rating = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

type EnergyArrowProps = {
  rating: Rating;
  src?: string;
  ratingLetterFontSize?: number;
  modalShows2ImagesIn1?: boolean;
  onModalToggleCallback?: (isOpen: boolean) => void;
};

/**
 * Energy Arrow component
 *
 * https://www.figma.com/file/s6zXyCh0ChKkr67JJfJRQa/EM-Web-Components?type=design&node-id=1531-22054&mode=design&t=uYMr7RUapOPVnD40-4
 */
export const EnergyArrow: FunctionComponent<EnergyArrowProps> = ({ ratingLetterFontSize = 14, ...props }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={styles['energy-arrow-container']}>
      <div
        data-testid={`energy-arrow-${props.src ? 'with' : 'without'}-src`}
        className={`${styles['energy-arrow']} ${props.src ? styles['clickable'] : ''}`}
        onClick={() => toggleModal(true)}
        style={
          {
            '--rating-font-size': `${ratingLetterFontSize ?? 14}px`,
          } as CSSProperties
        }
      >
        {getArrow()}
      </div>

      {isModalOpen && props.src && (
        <Modal
          isMobileFullScreen={true}
          isSidebar={false}
          isSidebarTablet={true}
          closeCallback={() => toggleModal(false)}
          className={styles[props.modalShows2ImagesIn1 ? 'modal-two-images' : 'modal-one-image']}
          isWhiteBackgroundColor={true}
        >
          <img
            src={props.src}
            alt={`energy-arrow-${props.rating}`}
            className={`${styles['energy-arrow-image']} ${props.modalShows2ImagesIn1 ? styles['energy-arrow-two-images'] : ''}`}
          />
        </Modal>
      )}
    </div>
  );

  function toggleModal(isOpen: boolean) {
    setIsModalOpen(isOpen);
    props.onModalToggleCallback && props.onModalToggleCallback(isOpen);
  }

  function getArrow() {
    switch (props.rating) {
      case 'A':
        return <ArrowA />;
      case 'B':
        return <ArrowB />;
      case 'C':
        return <ArrowC />;
      case 'D':
        return <ArrowD />;
      case 'E':
        return <ArrowE />;
      case 'F':
        return <ArrowF />;
      case 'G':
        return <ArrowG />;
    }
  }
};

export default EnergyArrow;
